export const SET_STATES = 'SET_STATES';
export const SET_CITIES = 'SET_CITIES';
export const SET_CLIENTS = 'SET_CLIENTS';
export const SET_SNIPPETS = 'SET_SNIPPETS';
export const SET_SNIPPET_GROUPS = 'SET_SNIPPET_GROUPS';
export const SET_VARIABLE_EXPENSES = 'SET_VARIABLE_EXPENSES';
export const SET_VARIABLE_COSTS = 'SET_VARIABLE_COSTS';
export const REMOVE_VARIABLE_COST = 'REMOVE_VARIABLE_COST';
export const ADD_VARIABLE_COST = 'ADD_VARIABLE_COST';
